import React, { Component } from "react";
import SEO from "react-seo-component";
import { Col, Container, Row } from "reactstrap";

class Section extends Component {
  getImage(trucktype) {
    try {
      return `https://media.qiktruck.co.za/3d-${trucktype}.png`;
    } catch (error) {
      return "";
    }
  }
  render() {
    return (
      <React.Fragment>
        <SEO
          title={
            "Earn more with QikTruck Boost | QikTruck | On Demand Truck and Driver Hire | Transportation Service"
          }
          titleTemplate={"QikTruck"}
          titleSeparator={`-`}
          description={
            "QikTruck Boost is a subscription service tailored for drivers of different truck types. By subscribing to Boost, drivers gain exclusive access to premium job quotations, the power to negotiate prices, and the flexibility to pass on jobs that don't suit their schedule or preferences."
          }
          image={"https://media.qiktruck.co.za/qiktruck-preview-header.png"}
          pathname={"/boost"}
          twitterUsername={"qiktrucksa"}
        />
        <section id="home">
          <Container>
            <Row className="justify-content-center">
              <Col>
                <div>
                  <h1>QikTruck Boost:</h1>
                  <br />
                  <h3> A New Way to Grow Your Transportation Business</h3>
                  <p>
                    At QikTruck, we understand the unique challenges and
                    opportunities faced by drivers in the logistics industry.
                    That's why we've developed QikTruck Boost, a groundbreaking
                    service designed to help drivers maximize their earnings,
                    grow their business, and maintain greater control over their
                    work.
                  </p>
                  <br />
                  <h2>What is QikTruck Boost?</h2>
                  <p>
                    QikTruck Boost is a subscription service tailored for
                    drivers of different truck types. By subscribing to Boost,
                    drivers gain exclusive access to premium job quotations, the
                    power to negotiate prices, and the flexibility to pass on
                    jobs that don't suit their schedule or preferences.
                  </p>
                  <br />

                  <h2>How Does It Work?</h2>
                  <p>
                    Once you subscribe to QikTruck Boost, you'll start receiving
                    premium job quotations. You can review these quotations at
                    your leisure, and if a job catches your eye, you have the
                    power to negotiate the price. This ensures that you're
                    always satisfied with the earnings potential of a job before
                    you commit to it.
                  </p>
                  <p>
                    One of the standout features of Boost is the ability to pass
                    on a job. We understand that not every job is the right fit
                    for every driver. Whether it's a scheduling conflict, a
                    distance issue, or any other reason, Boost gives you the
                    power to say no. When you pass on a job, you can provide a
                    reason, and the system will automatically reassign the
                    quotation to another driver.
                  </p>
                  <br />

                  <h2>How Much Does It Cost?</h2>
                  <p>
                    QikTruck Boost offers different subscription rates for
                    different truck types, providing flexibility and value for
                    all drivers. The monthly fees for each truck type are as
                    follows:
                  </p>
                  <p>
                    At QikTruck, we're committed to providing services that
                    address the unique needs of drivers in the logistics
                    industry. With Boost, we're confident that we're doing just
                    that.
                  </p>
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <p>
                  <br />
                  <i className="mdi mdi-note"></i> Remember... QikTruck will
                  always offer a Free version for our transporters to get jobs
                  on QikTruck EasyDrive.
                  <br />
                  <i className="mdi mdi-note"></i> All new partner drivers
                  automatically join the QikTruck Free program when documents
                  are approved.
                  <br />
                  <i className="mdi mdi-note"></i> You can Boost your profile if
                  there are no jobs in your area.
                </p>
                <p>
                  <i className="mdi mdi-star"></i>If your vehicle is already
                  approved. Boost your profile.
                </p>
              </Col>
            </Row>
          </Container>
        </section>
      </React.Fragment>
    );
  }
}

export default Section;
